class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('cart-recommendations');
        const hasProducts = recommendations && recommendations.querySelector('.mini-cart__navigation li');
        if (hasProducts) {
          this.innerHTML = recommendations.innerHTML;
        } else {
          this.style.display = 'none';
        }
      })
      .catch(e => {
        console.error(e);
        this.style.display = 'none';
      });
  }
}
customElements.define('cart-recommendations', CartRecommendations);

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-cart-upsell-variant-select]');
  if (!select) return;

  const button = select
    .closest('.cart-upsell-variant')
    ?.querySelector('[data-cart-upsell-add]');

  if (button) {
    button.dataset.variantId = select.value;
  }

  const price = select.closest('.product-description')?.querySelector('[data-cart-upsell-price]');
  const selected = select.selectedOptions[0];
  if (price && selected?.dataset.price) {
    price.textContent = selected.dataset.price;
  }
});
